import styled from "styled-components";
import { P, Pf } from "./Typography";
import theme from "../common/theme";

export const ListHeader = styled(P)`
    padding: 1rem;
    background: ${theme.palette.border};
    font-weight: 700;
    `

export default ListHeader;